import { OrderHeaderURLs } from '../../../../baseComponents/TwinTable/InputTableLayout/types'

const useSellOrderHeaderUrls = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '/api/app/order/sell/sellOrder/orderCost/createSellOrderCost',
        updateCost: '/api/app/order/sell/sellOrder/orderCost/updateSellOrderCost',
        deleteCost: '/api/app/order/sell/sellOrder/orderCost/deleteSellOrderCost',
        createFinancialRow: '/api/app/order/sell/sellOrder/orderFinancialRow/createSellOrderFinancialRow',
        updateFinancialRow: '/api/app/order/sell/sellOrder/orderFinancialRow/updateSellOrderFinancialRow',
        deleteFinancialRow: '/api/app/order/sell/sellOrder/orderFinancialRow/deleteSellOrderFinancialRow',
        createAccount: '/api/app/order/sell/sellOrder/orderAccount/createSellOrderAccount',
        updateAccount: '/api/app/order/sell/sellOrder/orderAccount/updateSellOrderAccount',
        deleteAccount: '/api/app/order/sell/sellOrder/orderAccount/deleteSellOrderAccount',
        createShipping: '/api/app/order/sell/sellShipping/createSellOrderShipping',
        updateShipping: '/api/app/order/sell/sellShipping/updateSellOrderShipping',
        createVariable: '/api/app/order/sell/sellOrder/orderVariable/createSellOrderVariable',
        updateVariable: '/api/app/order/sell/sellOrder/orderVariable/updateSellOrderVariable',
        deleteVariable: '/api/app/order/sell/sellOrder/orderVariable/deleteSellOrderVariable',
        updateWorkingCenter: '/api/app/order/sell/sellOrder/updateSellOrderWorkingCenter',
        createUpdateProductTypes: '/api/app/order/sell/sellOrder/orderProductType/createUpdateSellOrderProductTypes',
    }
    return orderHeaderURLs
}

export default useSellOrderHeaderUrls